/* 🤖 this file was generated by svg-to-ts */
export const siriusWrenchPictogram: {
  name: 'wrench_pictogram';
  data: string;
} = {
  name: 'wrench_pictogram',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style="display: block;"><path d="M41.044 13.313A11.98 11.98 0 0 1 24.206 28.5L13.688 40.688a4.508 4.508 0 0 1-6.376-6.375L19.5 23.793A11.981 11.981 0 0 1 34.688 6.957l-7.876 7.857 1.07 5.306 5.305 1.069 7.857-7.875Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`
};
